import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var videos = makeEntityScaffold('SAGA.API.VIDEOS', function (client, filters) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    brackets: true
  };
  return client.videos.getVideosList(filters, options);
});
export var onDemandVideos = makeEntityScaffold('SAGA.API.ON_DEMAND_VIDEOS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.videos.getOnDemandVideos(options);
});
export var videoCollection = makeEntityScaffold('SAGA.API.VIDEO_COLLECTION', function (client, collectionType, collectionName, flags) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return client.videos.getCollectionsByName(collectionType, collectionName, flags, options);
});
export var videoStacks = makeEntityScaffold('SAGA.API.VIDEO_STACKS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (// Massage cards data to match video details
    client.videos.getStacks(options).then(function (res) {
      return res.stacks.map(function (stack) {
        return _objectSpread({}, stack, {
          cards: stack.cards.map(function (card) {
            card.instructor = card.subtitle || card.instructor;
            card.thumbnail_large_url = card.image_path;
            card.partner = {
              alias: card.partner_alias
            };
            return card;
          })
        });
      });
    })
  );
});
export var videoDetails = makeEntityScaffold('SAGA.API.VIDEO_DETAILS', function (client, partnerAlias, videoAlias) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return client.videos.getVideoIdByLookup({
    partner_alias: partnerAlias,
    video_alias: videoAlias
  }, options).then(function (lookup) {
    return client.videos.getVideoById(lookup.id, {
      cp_home_beta: true
    }).then(function (data) {
      var streamUrl = data.stream_url || "https://player.ooyala.com/player/appletv/".concat(data.content_id, ".m3u8");
      return _objectSpread({}, data, {
        stream_url: streamUrl
      });
    });
  });
}, {
  defaultKey: 2
});
export var videoBookmarks = makeEntityScaffold('SAGA.API.VIDEO_BOOKMARKS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getUserVideoBookmarks(userId, options);
});
export var videosFilters = makeEntityScaffold('SAGA.API.VIDEO_FILTERS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    app: 'web'
  };
  return client.videos.getVideosFilters(options);
});
export var videoViewRatings = makeEntityScaffold('SAGA.API.VIDEO_VIEW_RATINGS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getVideoViewRatings(userId, {
    ratings_type: 'pending'
  }, options);
});
export var videoTracking = makeEntityScaffold('SAGA.API.VIDEO_TRACKING', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.videoEvents(userId, options).then(function (data) {
    return _objectSpread({
      video_id: options.video_id
    }, data);
  });
});
export var videoCompletedViews = makeEntityScaffold('SAGA.API.VIDEO_COMPLETED_VIEWS', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    view_type: 'completed'
  };
  return client.videos.getViewedVideos(userId, options);
});
export var liveVideos = makeEntityScaffold('SAGA.API.LIVE_VIDEOS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.videos.getLiveVideos(options);
});
export var liveVideoDetail = makeEntityScaffold('SAGA.API.LIVE_VIDEO_DETAILS', function (client, alias) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.videos.getLiveVideosById(alias, options);
}, {
  defaultKey: 1
});